const colors = {
  // FRN primary colors
  // https://drive.google.com/file/d/1d-0fp4AyIazxpXnKBq92RjjEQjqi_oqO/view
  green: {
    darkest: '#001c06',
    dark7: '#012a0a',
    dark6: '#01380d',
    dark5: '#024611',
    dark4: '#025414',
    dark3: '#026217',
    dark2: '#03701b',
    dark1: '#037e1e',
    primary: '#048d22',
    light1: '#1d9838',
    light2: '#36a34e',
    light3: '#4faf64',
    light4: '#68ba7a',
    light5: '#81c690',
    light6: '#9ad1a6',
    light7: '#b3dcbc',
    light8: '#cce8d2',
    light9: '#e5f3e8',
    lightest: '#f2f9f4'
  },
  orange: {
    darkest: '#331a00',
    dark7: '#4c2700',
    dark6: '#663400',
    dark5: '#7f4200',
    dark4: '#994f00',
    dark3: '#b25c00',
    dark2: '#cc6900',
    dark1: '#e57600',
    primary: '#ff8500',
    light1: '#ff9019',
    light2: '#ff9c33',
    light3: '#ffa84c',
    light4: '#ffb566',
    light5: '#ffc17f',
    light6: '#ffcd99',
    light7: '#ffdab2',
    light8: '#ffe6cc',
    light9: '#fff2e5',
    lightest: '#fff9f2'
  },
  purple: {
    darkest: '#180024',
    dark7: '#250036',
    dark6: '#310048',
    dark5: '#3e005a',
    dark4: '#4a006c',
    dark3: '#56007e',
    dark2: '#630090',
    dark1: '#6f00a2',
    primary: '#7d00b5',
    light1: '#8919bc',
    light2: '#9633c3',
    light3: '#a34ccb',
    light4: '#b066d2',
    light5: '#bd7fda',
    light6: '#ca99e1',
    light7: '#d7b2e8',
    light8: '#e4ccf0',
    light9: '#f1e5f7',
    lightest: '#f9f2fb'
  },
  bw: {
    darkest: '#000',
    dark1: '#111',
    primary: '#222',
    light1: '#383838',
    light2: '#4e4e4e',
    light3: '#646464',
    light4: '#7a7a7a',
    light5: '#909090',
    light6: '#a6a6a6',
    light7: '#bcbcbc',
    light8: '#d2d2d2',
    light9: '#e8e8e8',
    lightest: '#f4f4f4'
  },
  hyperlink: '#0090c8',
  // secondary: use for hyperlinks only
  necessity: '#ed3535' // secondary: use when "red" is a necessity
};

export default colors;
//# sourceMappingURL=color-palette.js.map